import { useEffect, useRef, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about-us" },
    { label: "Sports Programs", path: "/sports-programs" },
    // { label: "Blog", path: "/blog" },
    { label: "Gallery", path: "/gallery" },
    { label: "Contact Us", path: "/contact-us" },
  ];

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navbarToggleRef = useRef(null);

  const handleNavItemClick = (id) => {
    if (navbarToggleRef.current && window.innerWidth < 768) {
      navbarToggleRef.current.click();
    }
  };

  const data = [
    {
      src: "/assets/images/header/fb.png",
      link: "https://www.facebook.com",
    },
    {
      src: "/assets/images/header/linkedin.png",
      link: "https://www.linkedin.com",
    },
    {
      src: "/assets/images/header/x.png",
      link: "https://www.twitter.com", // previously Twitter, now X
    },
  ];

  const tophedaerLinks = [
    { path: "/leagal-disclaimer", label: "Leagal Disclaimer" },
    { path: "/privacy-policy", label: "Privacy Policy" },
    { path: "/terms-conditions", label: "Terms & Conditions" },
  ];

  return (
    <>
      <section className={`Header ${isScrolled ? "active" : ""}`}>



        <Container>
          <div className={`main_menu_navbar`}>
            <Navbar expand="md">
              <Navbar.Brand href="#home">
                <div className="logo_holder">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/logo.png"
                    }
                    alt="logo"
                    className="nav_logo"
                    onClick={() => navigate("/")}
                  />
                </div>
              </Navbar.Brand>

              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                ref={navbarToggleRef}
              />

              <Navbar.Collapse
                id="basic-navbar-nav"
                // className="d-none d-lg-block"
              >
                <div className="top_bar">
                  <Nav>
                    <>
                      {navItems.map((item, index) => (
                        <Nav.Link
                          as={Link}
                          to={item.path}
                          key={index}
                          className={
                            location.pathname === item.path ? "active" : ""
                          }
                          onClick={handleNavItemClick}
                        >
                          {item.label}
                        </Nav.Link>
                      ))}
                    </>
                  </Nav>
                </div>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </Container>


        {/* <div className="whatsappdiv">
          <a target="_blank" className="webwhats" href="https://web.whatsapp.com/send?phone=9096247296">
            <img className="whatsapp-img" src={process.env.PUBLIC_URL + '/assets/images/icons/whatsapp.png'} />
          </a>

          <a target="_blank" class="mobwhats" href="https://wa.me/9096247296">
            <img class="whatsapp-img" src={process.env.PUBLIC_URL + '/assets/images/icons/whatsapp.png'} />
          </a>
        </div> */}


      </section>
    </>
  );
}

export default Header;
